import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule, NgbHighlight, NgbActiveModal, NgbModule, NgbAccordion, NgbPanel, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { ConfigRoutingModule } from './config-routing.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AwbConfigComponent } from 'src/app/components/system-config/awb/awbconfig.component';
import { AWBService } from 'src/app/services/operations/awb.service';
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';
import { CompanyService } from 'src/app/services/company.service';
import { CustomerService } from 'src/app/services/customer.service';
import { NetworkService } from 'src/app/services/network.service';
import { InvoiceSeriesComponent } from 'src/app/components/system-config/invoice-series/invoiceseries.component';
import { SalesInvoiceService } from 'src/app/services/misc/sales/sales.service';
import { AWBDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/awb-delete.component';
import { ProductService } from 'src/app/services/products.service';
import { RateUploadService } from 'src/app/services/operations/rateupload.service';
import { RateBandsService } from 'src/app/services/ratebands.service';
import { TaxesService } from 'src/app/services/system-config/taxes/taxes.service';
import { AddTaxesComponent } from 'src/app/components/system-config/taxes/add/add.component';
import { EditTaxesComponent } from 'src/app/components/system-config/taxes/edit/edit.component';
import { VendorService } from 'src/app/services/vendor.service';
import { TemplatesComponent } from 'src/app/components/system-config/templates/templates.component';
import { TemplateService } from 'src/app/services/system-config/template/templates.service';
import { CreditControlComponent } from 'src/app/components/system-config/credit-control/creditcontrol.component';
import { CreditControlService } from 'src/app/services/system-config/credit-control/creditcontrol';
import { ConfigService } from 'src/app/services/system-config/configs/configs.service';
import { TATComponent } from 'src/app/components/system-config/tat/tat.component';
import { TATService } from 'src/app/services/system-config/tat/tat.service';
import { TATDetailsComponent } from 'src/app/components/system-config/tat/details/tatdetails.component';
import { TATPeriodComponent } from 'src/app/components/system-config/tat/periods/tatperiod.component';
import { DiscountComponent } from 'src/app/components/system-config/discount/discount.component';
import { DiscountService } from 'src/app/services/system-config/discount/discount.service';
import { DiscountPeriodComponent } from 'src/app/components/system-config/discount/period/period.component';
import { DiscountDetailsComponent } from 'src/app/components/system-config/discount/details/details.component';
import { DataImportComponent } from 'src/app/components/system-config/data-import/data-import.component';
import { DataImportService } from 'src/app/services/system-config/data-import/dataimport';
import { AddODAComponent } from '../../components/system-config/charges/oda/add/add.component';
import { ListVendorAWBComponent } from 'src/app/components/system-config/vendor-awb/list/list.component';
import { EditVendorAWBComponent } from 'src/app/components/system-config/vendor-awb/edit/edit.component';
import { AddVendorAWBComponent } from 'src/app/components/system-config/vendor-awb/add/add.component';
import { VendorAWBService } from 'src/app/services/vendorawb.service';
import { JOBQueueStatusRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/JOBQueueStatusRenderer';

@NgModule({
  declarations: [
    AwbConfigComponent,
    InvoiceSeriesComponent,
    AWBDeleteActionsRenderer,
    AddTaxesComponent,
    EditTaxesComponent,
    TemplatesComponent,
    CreditControlComponent,
    TATComponent,
    TATDetailsComponent,
    TATPeriodComponent,
    DiscountComponent,
    DiscountPeriodComponent,
    DiscountDetailsComponent,
    DataImportComponent,
    AddODAComponent,
    AddVendorAWBComponent,
    EditVendorAWBComponent,
    ListVendorAWBComponent,
  ],
  imports: [
    CommonModule,
    ConfigRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbHighlight,
    NgbNavModule,
    NgbDropdownModule,
    NgbTypeaheadModule,
    NgbPaginationModule,
    NgSelectModule,
    NgMultiSelectDropDownModule,
    NgbModule,
    AgGridModule
  ],
  exports: [
    AwbConfigComponent,
    InvoiceSeriesComponent,
    AWBDeleteActionsRenderer,
    AddTaxesComponent,
    EditTaxesComponent,
    TemplatesComponent,
    CreditControlComponent,
    TATComponent,
    TATDetailsComponent,
    TATPeriodComponent,
    DiscountComponent,
    DiscountPeriodComponent,
    DiscountDetailsComponent,
    DataImportComponent,
    AddODAComponent,
    AddVendorAWBComponent,
    EditVendorAWBComponent,
    ListVendorAWBComponent,
    AgGridModule,
  ],
  providers: [
    AWBService, ChargesService, CompanyService, CustomerService, NetworkService, SalesInvoiceService, ProductService, RateUploadService, RateBandsService, TaxesService, NgbActiveModal, 
    VendorService, TemplateService, CreditControlService, ConfigService, TATService,DiscountService,DataImportService, VendorAWBService
  ]
})
export class ConfigModule { }